var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"oauth"},[_c('OAuthCredentials'),_vm._v(" "),_c('OAuthRedirectUrls',{staticClass:"oauth__redirect-urls"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }